module.exports = __webpack_public_path__ + "fonts/10c620b6-7e51-4bcb-9ee6-6e6a2ffef4e6.e7e1f8c.ttf";